import { Injectable } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { GainsToastService } from 'app/shared/services/gains-toast-service/gains-toast.service';

@Injectable({
  providedIn: 'root'
})
export class FileSelectionService {
  private readonly _validExtensions = ['.txt', '.pdf', '.csv', '.md'];

  constructor(private readonly _gainsToastService: GainsToastService) {}

  beforeUpload(file: NzUploadFile, maxFileSize: number): File | null {
    const fileName = file.name.toLowerCase();
    const isValidType = this._validExtensions.some(ext => fileName.endsWith(ext));

    if (!isValidType) {
      this._gainsToastService.error('Invalid File Type', 'Only .txt, .pdf, .csv, and .md files are allowed');
      return null;
    }

    if (file.size && file.size > maxFileSize) {
      this._gainsToastService.error('File Too Large', `File size exceeds 5 MB limit (${(file.size / 1024 / 1024).toFixed(2)} MB)`);
      return null;
    }

    return file as unknown as File;
  }

  removeFile(): null {
    return null;
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  }

  getFileIcon(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'assets/icons/file-pdf.svg';
      case 'txt':
        return 'assets/icons/file-txt.svg';
      case 'csv':
        return 'assets/icons/file-csv.svg';
      case 'md':
        return 'assets/icons/file-md.svg';
      default:
        return 'assets/icons/file-default.svg';
    }
  }
}
